@if(!$destroyed()) {
    <div class="container">

        @if($iconEffective(); as icon) {
            <div class="icon">
                <i [class]="icon" style="font-size: 16px;"></i>
            </div>
        }

        <div class="details">
            @if($summary(); as summary) {
                <div class="summary">{{summary}}</div>
            }

            <div class="detail">
                @if($detail(); as detail) {
                    {{detail}}
                }

                <ng-content></ng-content>
            </div>

            @if($actions()?.length > 0) {
                <div class="actions">
                    @for(command of $actions(); track $index) {
                        <w-button mode="Link" size="Medium" [command]="command" />
                    }
                </div>
            }
        </div>


        @if($closable()) {
            <div class="close">
                <w-button mode="Link" size="Medium" iconLeft="fa-regular fa-xmark" displayStyle="Tertiary" (onClick)="onClose($event)" />
            </div>
        }

    </div>
}